import React from 'react';
import Form from './components/Form/Form';
import { ModalWindows } from './components/ModalWindows';
import CreateDeviceState from './createDeviceState/CreateDeviceState';

const CreateDevicePage: React.FC = () => {
	return (
		<CreateDeviceState>
			<Form />
			<ModalWindows />
		</CreateDeviceState>
	);
};

export default CreateDevicePage;
